// extracted by mini-css-extract-plugin
export default {"container":"cfzaw","title":"RySr2","description":"QN4vw","descriptionText":"ZdE26"};